import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_BOOSTER } from '@/modules/booster/router';
import { boosterService } from '@/services/booster';
import useVuelidate from '@vuelidate/core';
import { minValue, numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

const TOTAL_COST_OPTION = 3;
export class BoosterItemCost {
    constructor(public quantity: number = 0, public cost: number = 0, public discountRate: number = 0) {}

    toString(): string {
        return [this.quantity, this.cost, this.discountRate].join(StringUtils.Characters.Colon);
    }

    static fromString(data: string): BoosterItemCost | null {
        const [quantity, cost, discountRate] = data.split(StringUtils.Characters.Colon).map(Number);
        return new BoosterItemCost(quantity, cost, discountRate);
    }
}

export function useMixins() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        type: StringUtils.toNumber(route.params.type),
        name: null,
        initValue: 0,
        thumbnail: null,
        thumbnailFile: null,
        costList: Array(TOTAL_COST_OPTION)
            .fill(null)
            .map(() => new BoosterItemCost()),

        get costs() {
            return this.costList.map(item => item.toString()).join(StringUtils.Characters.Semicolon);
        }
    });

    const validations = {
        name: { required },
        type: { required },
        initValue: { required, numeric, minValue: minValue(0) },
        costs: { required, format: validateFormat(/^\d+:\d+:\d+(;\d+:\d+:\d+)*$/) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        canExecute: () => model.type != null,
        request: () => boosterService.get(model.type),
        onSuccess: ({ data }) => {
            model.name = data.name;
            model.thumbnail = data.thumbnail;
            model.initValue = data.initValue;
            model.costList = data.costs.split(StringUtils.Characters.Semicolon).map(BoosterItemCost.fromString);
            while (model.costList.length < TOTAL_COST_OPTION) model.costList.push(new BoosterItemCost());
        }
    });

    const actions = {
        create: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                boosterService.create(model.type, model.name, model.initValue, model.costs, model.thumbnailFile),
            onSuccess: () => router.push({ name: ROUTE_NAME_BOOSTER.INDEX })
        }),
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                boosterService.update(model.type, model.name, model.initValue, model.costs, model.thumbnailFile),
            onSuccess: () => router.push({ name: ROUTE_NAME_BOOSTER.INDEX })
        })
    };

    return { v$, model, fetch, actions };
}

export const Options = {
    ItemType: [
        { value: 1, label: 'Shuffle' },
        { value: 2, label: 'Search' },
        { value: 3, label: 'Locate' },
        { value: 4, label: 'Fifty' },
        { value: 5, label: 'TimeExtend' },
        { value: 6, label: 'ChangeQuestion' }
    ]
};
